/* @ngInject */
const myInvoiceForm = (
  invoicingFields,
  $$owner,
  toaster,
  valueHandler,
  optionsHandler,
  utils
) => {
  return {
    restrict: 'E',
    scope: {
      myInvoice: '=',
      enableValidator: '=?',
    },
    template: require('./myInvoiceForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = invoicingFields

      $scope.invoicingChoiceRadio = [{
        label: 'Mètres linéaire',
        id: 'linear',
        value: 'linear',
      }, {
        label: '€ / jour / wagon',
        id: 'daily',
        value: 'daily',
      }, {
        label: '€ / jour / wagon limité',
        id: 'dailyLimited',
        value: 'dailyLimited',
      }, {
        label: 'Part fixe - Part variable',
        id: 'fixVar',
        value: 'fixVar',
      },]
    },
    link: {
      pre: (scope, element, attrs) => {

        const defaultInvoice = {
          choice: 'linear',
          dateBegin: utils.date.getBeginOfMonthString(),
          dateEnd: utils.date.getEndOfMonthString(),
          unparkCost: 150,
          provisionCost: 150,
          linearMeterCost: 0,
          fixedPartCost: 0,
          wagonCost: 0,
          limitWagonLength: 0,
          fixedPartLength: 0,
        }

        scope.myInvoice = optionsHandler.setDefaults(scope.myInvoice, defaultInvoice)
        scope.enableValidator = scope.enableValidator || false
      },
      post: async (scope, element, attrs, ctrl) => {
        try {
          const response = await $$owner.request.getAll()
          scope.owners = response.owners
        } catch (error) {
          toaster.error(error)
        }

        scope.$watch('myInvoice', (newInvoice, oldInvoice) => {
          if (newInvoice !== oldInvoice && valueHandler.isObject(newInvoice)) {
            if (!valueHandler.isString(newInvoice.choice)) {
              newInvoice.choice = 'linear'
            }
          }
        })
      },
    },
  }
}
export default myInvoiceForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/invoicing/directives/form/myInvoiceForm.js